import {  React, useState, api, toast, API_URL, Modal  } from "../../../services/common"


const AddLead = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        source: '',
        course: '',
        tutor: '',
        notes: [],
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        
        // Special handling for notes: keep it as array
        if (name === "notes") {
            if (value.trim() === "") {
                // Empty value → clear notes array
                setFormData({
                    ...formData,
                    notes: []
                });
            } else {
                // Add/replace first note object
                setFormData({
                    ...formData,
                    notes: [{
                        note: value,
                        date: new Date().toISOString()
                    }]
                });
            }
        } else {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await api.post( API_URL + '/common/leads', formData);
            toast.success('Lead added successfully!');
            console.log(response.data);
            setFormData({
                name: '',
                email: '',
                phone: '',
                source: '',
                notes: [],
                status: '',
                course: '',
                tutor: '',
            });
        } catch (error) {
            console.error('Error adding lead:', error);
            toast.error('Failed to add lead. Please try again.');
        }
    };

    return (
        <div>
            <h2>Add Lead</h2>
            <form onSubmit={handleSubmit}>
                <div>
                    <label>Name:</label>
                    <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        
                    />
                </div>
                <div>
                    <label>Email:</label>
                    <input
                        type="text"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        
                    />
                </div>
                <div>
                    <label>Phone Number:</label>
                    <input
                        type="text"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        
                    />
                </div>
                <div>
                    <label>Source:</label>
                    <input
                        type="text"
                        name="source"
                        value={formData.source}
                        onChange={handleChange}
                    />
                </div>

                <div>
                    <label>Course</label>
                    <input
                        type="text"
                        name="course"
                        value={formData.course}
                        onChange={handleChange}
                    />
                </div>

                <div>
                    <label>Tutor</label>
                    <input
                        type="text"
                        name="tutor"
                    value={formData.tutor}
                        onChange={handleChange}
                    />
                </div>
                <div>
                    <label>Notes:</label>
                    <textarea
                        name="notes"
                        value={formData.notes[0]?.note || ''}
                        onChange={handleChange}
                    ></textarea>
                </div>
                <button type="submit">Add Lead</button>
            </form>
        </div>
    );
};

export default AddLead;